import * as yup from 'yup'

import { persianTranslationRequired } from '../../../helpers/persianNameValidation'
import { timeRegex } from '../../../helpers/regex'

export const accommodationFormValidationSchema = yup.object().shape({
  basicDetails: yup.object().shape({
    name: yup.string().required('This field is required'),
    /*
     * The Persian name is required by the asset service, and was not required here.
     *
     * The form seeds one entry with an empty value, so submitting an unfilled form sent it
     * onward and came back as `rpc error: ... NameFA: NameFA field is required` — a backend
     * field name matching no label on this screen. It was reported as "it wants a Persian name
     * but there is no field for one", which is the only reading that error allows.
     *
     * A .test() rather than .required() on the array: the entry exists and is seeded by the
     * form, so it is the VALUE that is missing and .required() on the list would pass.
     */
    nameTranslatedList: persianTranslationRequired(),
    propertyCode: yup.string().required('This field is required'),
    resourceType: yup.string().required('This field is required'),
    website: yup
      .string()
      .url('Enter a valid address with protocol(for example: https://)')
      .required('This field is required'),
    description: yup.string().required('This field is required'),
    timeZone: yup.string().required('This field is required'),
    tenantId: yup.string().required('This field is required'),
    totaRoomNumber: yup
      .number()
      .typeError('Enter a number')
      .min(0, 'Enter a number bigger than 0')
      .notOneOf([0], 'This field is required'),
    checkinFrom: yup
      .string()
      .matches(timeRegex, 'Time must be in the format HH:MM')
      .required('This field is required'),
    checkinTo: yup
      .string()
      .matches(timeRegex, 'Time must be in the format HH:MM')
      .required('This field is required'),
    checkoutFrom: yup
      .string()
      .matches(timeRegex, 'Time must be in the format HH:MM')
      .required('This field is required'),
    checkoutTo: yup
      .string()
      .matches(timeRegex, 'Time must be in the format HH:MM')
      .required('This field is required')
  }),
  addressDetails: yup.object().shape({
    country: yup
      .object()
      .shape({
        label: yup.string().required('This field is required'),
        value: yup.string().required('This field is required'),
        id: yup.string().required('This field is required'),
        code: yup.string().required('This field is required')
      })
      .not(
        [{ label: '', value: '', id: '', code: '' }],
        'This field is required'
      ),
    city: yup.string().required('This field is required'),
    postalCode: yup.string().required('This field is required'),
    address: yup.string().required('This field is required'),
    latitude: yup
      .number()
      .typeError('Enter a number')
      .min(0, 'Enter a number bigger than 0')
      .notOneOf([0], 'This field is required'),
    longitude: yup
      .number()
      .typeError('Enter a number')
      .min(0, 'Enter a number bigger than 0')
      .notOneOf([0], 'This field is required')
  }),
  contactDetails: yup.object().shape({
    email: yup
      .string()
      .email('Enter a valid email address')
      .required('This field is required'),
    bookingConfirmationEmail: yup
      .string()
      .email('Enter a valid email address')
      .required('This field is required'),
    bookingFailReportEmail: yup
      .string()
      .email('Enter a valid email address')
      .required('This field is required'),
    bookingConfirmationPhoneNumber: yup
      .string()
      .required('This field is required'),
    bookingFailReportPhoneNumber: yup
      .string()
      .required('This field is required'),
    fax: yup.string().required('This field is required'),
    bookingConfirmationFax: yup.string().required('This field is required')
  }),
  // wbsDetails: yup.object().shape({
  //   overrideRedirect: yup.boolean(),
  //   bookingRedirect: yup.string().when('overrideRedirect', {
  //     is: true,
  //     then: yup
  //       .string()
  //       .url('Enter a valid address with protocol(for example: https://)')
  //       .required('This field is required')
  //   })
  // }),
  inventoryAndBooking: yup.object().shape({
    canReserveCombination: yup.boolean(),
    currencies: yup
      .array()
      .of(yup.string())
      .min(1, 'Select at least one currency')
      .required('This field is required')
  })
})
